<template>
  <input
    :value="inputValue"
    @input="handleInput"
    @keypress="handleKeyPress"
    type="text"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "AlphaNumericInput",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const inputValue = ref(props.modelValue);

    watch(
      () => props.modelValue,
      (newValue) => {
        inputValue.value = newValue;
      }
    );

    const handleInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const sanitizedValue = input.value.replace(/[^a-zA-Z0-9]/g, "");
      input.value = sanitizedValue; // テキストボックスの値を直接更新
      emit("update:modelValue", sanitizedValue);
    };

    const handleKeyPress = (event: KeyboardEvent) => {
      const regex = /^[a-zA-Z0-9]*$/;
      if (!regex.test(event.key)) {
        event.preventDefault();
      }
    };

    return {
      inputValue,
      handleInput,
      handleKeyPress,
    };
  },
});
</script>
<style scoped></style>
